import React from 'react';
import { Typography } from '@mui/material';

import RecommendationIconGroup from '../general/RecommendationIconGroup';
import { formatNumber } from '../../lib/utils';

export default function BuildingCardMenu({
  recommendations,
  propertyType,
  area
}) {
  return (
    <div className="building-card-meta">
      {recommendations && <RecommendationIconGroup {...recommendations} />}
      {propertyType && (
        <Typography
          sx={{
            lineHeight: 'initial'
          }}
          color="textSecondary"
          variant="overline"
        >
          {propertyType}
        </Typography>
      )}
      {area && (
        <Typography
          sx={{
            lineHeight: 'initial',
            align: 'flex-end'
          }}
          color="textSecondary"
          variant="overline"
        >
          {formatNumber(area * 10.7639)} ft²
        </Typography>
      )}
    </div>
  );
}
